import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function ApprovalBanner() {
  return <div className="bg-black text-white w-full py-3 px-4 sticky top-0 z-50 shadow-md" style={{
    fontFamily: "'Inter', system-ui, sans-serif"
  }} data-id="element-11">
      <div className="max-w-4xl mx-auto flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-sm sm:text-base md:text-lg font-bold tracking-wide text-center" data-id="element-12">
        <span className="flex items-center gap-1 text-green-400" data-id="element-13">
          <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-14" />
          APPROVED:
        </span>
        <span data-id="element-15">New 2026 Bathroom Remodel Service</span>
      </div>
    </div>;
}